import React, { useState, useRef, useEffect } from "react";
import { TbTableColumn } from "react-icons/tb";
import PropTypes from "prop-types";

const ColumnVisibilityControl = ({ gridApi, columnVisibility, toggleColumn }) => {
  const [colDropdownOpen, setColDropdownOpen] = useState(false);
  const colDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (colDropdownRef.current && !colDropdownRef.current.contains(e.target)) {
        setColDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const columns = gridApi?.getColumns()?.filter((col) => col.getColDef().headerName) || [];

  return (
    <div ref={colDropdownRef} style={{ position: "relative", flexGrow: 0 }}>
      <button
        className="input_styling"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          cursor: "pointer",
          padding: "17px 10px",
          marginTop: "5px",
          whiteSpace: "nowrap",
        }}
        onClick={() => setColDropdownOpen((prev) => !prev)}
        title="Show / Hide Columns"
      >
        <TbTableColumn size="2.4em" />
        <span>Columns</span>
      </button>

      {colDropdownOpen && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #E8FBFB",
            borderRadius: 6,
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            padding: "8px 0",
            minWidth: 180,
            maxHeight: 300,
            overflowY: "auto",
          }}
        >
          {columns.map((col) => {
            const colId = col.getColId();
            const headerName = col.getColDef().headerName;
            const isVisible = columnVisibility[colId] !== false;
            return (
              <label
                key={colId}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "5px 14px",
                  cursor: "pointer",
                  fontSize: 13,
                  userSelect: "none",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#E8FBFB")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <input
                  type="checkbox"
                  checked={isVisible}
                  onChange={() => toggleColumn(colId)}
                  style={{ cursor: "pointer" }}
                />
                {headerName}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

ColumnVisibilityControl.propTypes = {
  gridApi: PropTypes.object,
  columnVisibility: PropTypes.object.isRequired,
  toggleColumn: PropTypes.func.isRequired,
};

export default ColumnVisibilityControl;
